import React from 'react';
import { Highlight } from './Highlight';
import { MockWindow } from './MockWindow';
export function SecureMockup() {
  return <MockWindow data-id="element-171" data-mp="61otndmzdroo">
      <div className="px-[3cqw] py-[2.2cqw]" data-id="element-172" data-mp="626tslcrkq1v">
        <div className="w-[30cqw]" data-id="element-173" data-mp="3ohhippdqetil">
          <p className="text-[1.6cqw] font-semibold text-mm-black" data-id="element-174" data-mp="3ogg4jc1f5qwn">Keep your account secure</p>
          <p className="mt-[0.6cqw] text-[1.05cqw] leading-[1.4] text-mm-mid-gray" data-id="element-175" data-mp="3terc1g48rpbp">
            Stripe requires <span className="text-[#635BFF]" data-id="element-176" data-mp="3eh8g9tt5cbur">two-step authentication</span> to
            keep your account secure.
          </p>
          <p className="mt-[1.4cqw] text-[1cqw] font-medium text-mm-muted-charcoal" data-id="element-177" data-mp="3jfic86mp3ghf">
            Choose a method
          </p>
          <div className="mt-[0.6cqw] flex h-[2.6cqw] items-center justify-center border border-mm-light-gray text-[1.05cqw] font-medium text-mm-charcoal" data-id="element-178" data-mp="3agx0ovfn51q5">
            Add security key
          </div>
          <Highlight tone="go" tag="Click" className="mt-[1cqw]" data-id="element-179" data-mp="18qd43bsa5rec">
            <div className="flex h-[2.6cqw] items-center justify-center border border-mm-light-gray text-[1.05cqw] font-medium text-mm-charcoal" data-id="element-180" data-mp="18nqu75hx2zsy">
              Add authenticator app
            </div>
          </Highlight>
          <p className="mt-[0.8cqw] text-center text-[1cqw] text-mm-mid-gray" data-id="element-181" data-mp="34pyxr52fj8if">
            Show additional options
          </p>
          <div className="mt-[1.4cqw] flex h-[2.6cqw] items-center justify-center bg-[#635BFF]/40 text-[1.05cqw] font-semibold text-white" data-id="element-182" data-mp="2zs6ujewc3zyx">
            Continue
          </div>
        </div>
      </div>
    </MockWindow>;
}